import axios from "axios";
import config from "@/config";
import router from "@/core/router";
import i18n from "@/core/i18n";

const client = axios.create({
  baseURL: config.apiRoot,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

client.interceptors.request.use((config) => {
  if (config.data) {
    config.data.lang = i18n.global.locale;
  }
  return config;
});

client.interceptors.response.use((response) => {
  if (response.data.status !== "ok") {
    console.error("API Error :", response.data.detail, "\n", response);
    if (response.data.detail === "La connexion n'est plus valide") {
      localStorage.removeItem("token");
      router.push({
        path: "/login",
        state: { redirectTo: router.currentRoute.value.path },
      });
    }
    throw new Error(response.data.detail);
  }
  return response;
});

client.interceptors.request.use((request) => {
  request.headers = {
    ...request.headers,
    Authorization: `Bearer ${localStorage.token}`,
  };
  return request;
});

export default client;
